import React, { type ComponentProps } from 'react';

import { Communication } from '@poseidon/components/StrokeIcons';

import { cn } from '@poseidon/components/cn';

import styles from './ErrorMessage.module.scss';

type ErrorMessageProps = ComponentProps<'div'> & {
  error?: string;
  details?: string;
};

export const ErrorMessage = ({ error, details, children, className }: ErrorMessageProps) => {
  if (children) {
    if (details != null) {
      return (
        <span className={cn(styles.error, className)}>
          <div>
            <Communication.AnnotationAlert className={styles.exclamation} /> {children}
          </div>
          <div className={styles.errorDesc}>{details}</div>
        </span>
      );
    } else {
      return (
        <span className={cn(styles.error, className)}>
          <Communication.AnnotationAlert className={styles.exclamation} /> {children}
          {details != null && <span>{details}</span>}
        </span>
      );
    }
  }
  if (error) return <span className={cn(styles.error, className)}>{error}</span>;
  return null;
};

export const FieldError = ({ children }: { children?: React.ReactNode }) => {
  return <span className={cn(styles.simpleError)}>{children}</span>;
};

export const WarningMessage = ({ error, children, className }: ErrorMessageProps) => {
  if (children) return <span className={cn(styles.warning, className)}>⚠️ {children}</span>;
  if (error) return <span className={cn(styles.warning, className)}>{error}</span>;
  return null;
};

export const InfoMessage = ({ children, className }: ErrorMessageProps) => {
  if (children) return <span className={cn(styles.info, className)}>{children}</span>;
  return null;
};
